import api from '../../utils/api';
import { StoredFileMetadata } from '../shared/types';

interface FindFileSignedUrlResponse {
    url: string;
}

const findFileSignedUrl = async (params: StoredFileMetadata['params']): Promise<FindFileSignedUrlResponse> => {
    return await api.getWithoutAuth('api/file/signed-url', params);
}

export default findFileSignedUrl;
